import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ICoreService } from '../../../interfaces/core-service.interface';
import { NgxSpinnerService } from 'ngx-spinner';
import { CoreService_TOKEN } from '../../../tokens/injection-tokens';
import { ControlBase } from '../../base/control-base/control-base.component';

@Component({
    selector: 'html-viewer-control',
    templateUrl: './html-viewer.control.html',
    standalone: false,
})
export class HtmlViewerControl extends ControlBase {
    @Input() texthtml: string = '';
    get sanitizedHtml() {
        return this.sanitizer.bypassSecurityTrustHtml(this.texthtml);
    }

    constructor(
        @Inject(CoreService_TOKEN)
        private coreService: ICoreService,
        protected override spinnerService: NgxSpinnerService,
        private sanitizer: DomSanitizer
    ) {
        super(spinnerService);
    }

    public ngOnInit() {}
}
